import { render } from "./CompleatedOrdersView.vue?vue&type=template&id=46c1de41"
import script from "./CompleatedOrdersView.vue?vue&type=script&lang=js"
export * from "./CompleatedOrdersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__